import flightTask from './flightTask'

export default {
  flightTask,
}
